import Splide from "@splidejs/splide";
import { opinionSlider } from "../sliders/sliders";

export default class SwitchActiveLogo {
    private wrapper: HTMLElement | null;
    private companyLogos: HTMLElement[] | null;
    private opinionWrapper: HTMLElement | null;
    private sliderElements: HTMLElement[] | null;
    private slider: Splide | null = null;

    constructor(wrapper: HTMLElement) {
        this.wrapper = wrapper;
        this.opinionWrapper = document.querySelector("#opinion-slider");
        this.companyLogos = [...this.wrapper.querySelectorAll<HTMLElement>(".company-logo-wrapper")];
        this.sliderElements = [...document?.querySelectorAll<HTMLElement>(".opinion-item")];

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.opinionWrapper) return;
        this.slider = opinionSlider(this.opinionWrapper);

        this.slider.on("active", () => {
            this.findActiveElement();
        });

        this.moveSlider();
    };

    private findActiveElement = () => {
        const activeSlider = this.sliderElements?.filter((slider) => slider.classList.contains("is-active")) as HTMLElement[];

        if (activeSlider?.length < 1) return;

        this.companyLogos?.forEach((logo) => {
            if (logo.dataset.client === activeSlider[0].dataset.clientOpinion) this.setActiveElement(logo);
        });
    };

    private setActiveElement = (activeLogo) => {
        this.companyLogos?.forEach((item) => item.classList.remove("company-logo-wrapper--active"));

        activeLogo.classList.add("company-logo-wrapper--active");
    };

    private moveSlider = () => {
        this.companyLogos?.forEach((logo, index) => {
            const img = logo.querySelector("img") as HTMLImageElement;

            img.addEventListener("click", () => {
                if (!this.slider) return;

                this.slider.go(index);
            });
        });
    };
}
